import { useNavigate } from 'react-router-dom';
import { Lock, LogIn, UserPlus } from 'lucide-react';

const GatedContent = ({ children, previewContent }) => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  if (user) return children;

  return (
    <div className="relative" data-testid="gated-content">
      <div className="select-none pointer-events-none" style={{ filter: 'blur(7px)' }}>
        {previewContent || (
          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            <div className="space-y-4">
              <div className="h-5 bg-gray-200 rounded-full w-3/4" />
              <div className="h-4 bg-gray-100 rounded-full w-full" />
              <div className="h-4 bg-gray-100 rounded-full w-5/6" />
              <div className="h-4 bg-gray-100 rounded-full w-2/3" />
              <div className="h-20 bg-gray-50 rounded-xl w-full mt-6" />
              <div className="h-4 bg-gray-100 rounded-full w-full" />
              <div className="h-4 bg-gray-100 rounded-full w-4/5" />
              <div className="h-5 bg-gray-200 rounded-full w-1/2 mt-6" />
              <div className="h-4 bg-gray-100 rounded-full w-full" />
              <div className="h-4 bg-gray-100 rounded-full w-3/4" />
            </div>
          </div>
        )}
      </div>

      <div className="absolute inset-0 flex items-center justify-center" data-testid="login-overlay">
        <div className="bg-white/95 backdrop-blur-md rounded-2xl p-8 shadow-2xl text-center max-w-sm border border-gray-100 mx-4">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#eaf6fc] to-[#d5ecf5] flex items-center justify-center mx-auto mb-5">
            <Lock size={26} className="text-[#35AFE4]" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Barlow', sans-serif" }}>
            Contenu réservé aux membres
          </h3>
          <p className="text-gray-500 text-sm mb-6 leading-relaxed">
            Connectez-vous ou adhérez à la SFOALC pour accéder à l'intégralité du contenu.
          </p>
          <div className="flex flex-col gap-3">
            <button
              onClick={() => navigate('/auth')}
              className="flex items-center justify-center gap-2 px-6 py-3 bg-[#1e3a5f] text-white rounded-full font-bold text-sm hover:bg-[#162d4a] transition-all hover:shadow-lg hover:scale-[1.02] active:scale-[0.98]"
              data-testid="gated-login-btn"
            >
              <LogIn size={16} /> Se connecter
            </button>
            <button
              onClick={() => navigate('/adhesion')}
              className="flex items-center justify-center gap-2 px-6 py-3 border-2 border-[#35AFE4] text-[#35AFE4] rounded-full font-bold text-sm hover:bg-[#eaf6fc] transition-all hover:scale-[1.02] active:scale-[0.98]"
              data-testid="gated-register-btn"
            >
              <UserPlus size={16} /> Adhérer à la SFOALC
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GatedContent;
